import React from 'react';
import { useRecordContext } from 'react-admin';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

const ParticipantsListField = (props) => {
    const record = useRecordContext();

    if (!record || !record.participants || record.participants.length === 0) {
        return (
            <Typography
                variant="body2"
                sx={{ color: '#999', pointerEvents: 'none' }}
            >
                —
            </Typography>
        );
    }

    return (
        <Box
            sx={{ display: 'flex', gap: '4px', flexWrap: 'wrap', pointerEvents: 'none' }}
        >
            {record.participants.map((user) => (
                <Chip
                    key={user.id}
                    label={user.trigram}
                    size="small"
                    variant="outlined"
                />
            ))}
        </Box>
    );
};

export default ParticipantsListField;
